import type { LanguageCode } from '../../features/Settings/utils/languageUtils';

// The country a site belongs to is encoded in the first two characters of its
// site code (`BR011288`, `FR000042`, `SO01199`). France owns two prefixes —
// `FR` and `SO` — confirmed with Aurelien during #830244's refinement. Same
// convention as `shouldShowAccessibilityLabel.ts`'s ACCESSIBILITY_LABEL_SITE_PREFIXES.
const SITE_PREFIX_LANGUAGE: Partial<Record<string, LanguageCode>> = {
  BR: 'pt',
  FR: 'fr',
  SO: 'fr',
};

export const resolveLanguageFromSiteCode = (siteCode: string): LanguageCode =>
  SITE_PREFIX_LANGUAGE[siteCode.slice(0, 2).toUpperCase()] ?? 'en';

export const hasMappedLanguage = (siteCode: string): boolean =>
  siteCode.slice(0, 2).toUpperCase() in SITE_PREFIX_LANGUAGE;
